import { ReCaptcha } from './reCaptcha';

export class UnSubscribe {
    public unSubscribeId: string;
    public reCaptcha: ReCaptcha;
    
    constructor() {
       this.unSubscribeId = '';
    }
}